import * as React from 'react';
import {useState} from 'react';
import Auth from "./auth";
import Localization from "./components/localization";
import {UiStateContext, UiStateStore} from "./stores/ui-state.store";
import ViaMParticleReporter from 'via-city-tools-m-particle';
import stageParameters from "./constants/env";
import {configureAuthClient} from "./auth-client";

interface OwnProps {
    queryParams: string;
    stage: string;
}

const LoginApp = (props: OwnProps) => {
    const [uiStateStore] = useState(new UiStateStore());
    const { queryParams, stage} = props;
    const locale = window.navigator.language;
    const parameters = stageParameters[stage];
    const cognitoUserPool = parameters.userPoolId;
    const cognitoAppClientID = parameters.cognitoClientId;
    const isViaForSchools = process.env.REACT_APP_IS_SB === 'true';
    const params = new URLSearchParams(queryParams);
    const env =  params.has("redirect_uri") ?
        params.get("redirect_uri").replace("/parseauth", "") : window.location.origin;
    configureAuthClient(stage, isViaForSchools, cognitoUserPool, cognitoAppClientID);

    new ViaMParticleReporter(
        stage !== 'prod',
        'us1-4ae99a513b3beb41af44d90406ecaf2f',
        env,
        null,
        null,
    );

    return(
            <Localization locale={locale}>
                <UiStateContext.Provider value={uiStateStore}>
                    <Auth isViaForSchools={isViaForSchools} queryParams={queryParams}
                          stage={stage} cognitoUserPool={cognitoUserPool}
                          cognitoAppClientID={cognitoAppClientID}/>
                </UiStateContext.Provider>
            </Localization>
        );
};

LoginApp.defaultProps = {
    queryParams: "",
};


export default LoginApp;
